import { fields } from '../../pages/Sandbox/components/AvailableFields/FieldDefinitions'
import { observer } from 'mobx-react-lite'
import styles from './RenderField.module.css'
import { Controller } from 'react-hook-form'
import { Form } from 'antd'

const RenderField = observer(
  ({
    field,
    errors,
    isActiveSubmit,
    control,
    setValue,
    isDuplicateConflict,
  }) => {
    const fieldDefinition = fields.find((def) => def.type === field.type)
    let error = errors[field.idFieldCanvas]

    if (isDuplicateConflict && field.is_axis_key && !error) {
      error = {
        message: 'Ce champ a causé un conflit de duplication',
      }
    }

    const field_style = field.design ? { ...field.design } : {}
    const label_style = field.label_design ? { ...field.label_design } : {}
    const description_style = field.description_design
      ? { ...field.description_design }
      : {}

    if (!fieldDefinition) {
      console.error(`No definition found for field type "${field.type}"`)
      return null
    }

    const FieldComponent = fieldDefinition.component

    if (!FieldComponent) {
      console.error(`No component found for field type "${field.type}"`)
      return null
    }

    const renderLabelAndDescription = () => {
      if (field.type === 'url' && field.url_target) {
        return (
          <a
            href={field.url_target}
            target="_blank"
            rel="noopener noreferrer"
            style={{ cursor: 'pointer', textDecoration: 'none' }}
          >
            <div style={label_style} className={styles.label}>
              {field.label}
              {field.required && ' *'}
            </div>
            {field.descriptionVisible && (
              <div style={description_style} className={styles.description}>
                {field.description}
              </div>
            )}
          </a>
        )
      }

      return (
        <>
          <div style={label_style} className={styles.label}>
            {field.label}
            {field.required && ' *'}
          </div>
          {field.descriptionVisible && (
            <div style={description_style} className={styles.description}>
              {field.description}
            </div>
          )}
        </>
      )
    }

    return (
      <div style={field_style} className={`${styles.field}`}>
        <div className="main__container__field">
          {renderLabelAndDescription()}
          <div className={`render_container__input__fields`}>
            <FieldComponent
              className={styles.input}
              field={field}
              isActiveSubmit={isActiveSubmit}
              control={control}
              errors={errors}
              setValue={setValue}
            />
            {error && (
              <div
                onClick={() => console.log(errors)}
                className={styles.errorText}
              >
                {error.message}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
)

export default RenderField
